// Hey everyone! This site is riddled with easter eggs....happy hunting!

export default class EasterEggs {
    constructor() {
        this.setEntertainmentGif();
    }

    setEntertainmentGif() {
        let images = [
            // shake weight
            //'https://media.giphy.com/media/IlunDcXxfjeIE/giphy.gif',
            'https://media.giphy.com/media/tq7X177LuFhEk/giphy.gif',
            'https://media.giphy.com/media/Gv2eGznFZKVHO/giphy.gif',
            'https://media.giphy.com/media/eDQakjNyQV584/giphy.gif',
            'https://media.giphy.com/media/Zw37jJyLJluKs/giphy.gif',
            'https://media.giphy.com/media/zxY2k7bLpMGNa/giphy.gif'
        ];
        let src = images[Math.floor(Math.random() * 3)];
        src = (src === 'undefined') ? images[0] : src;
        $(document).find('#gag-image').attr('src', src);
    }
} 


// WEBPACK FOOTER //
// ./public/js/EasterEggs.js